import React from "react";
import Check4CancerBannerSrc from "../assets/img/cancer/Check4Cancer-Header-Banner_1440x300.jpg";
import Check4CancerBannerSrcMobile from "../assets/img/cancer/Check4Cancer-Header-Banner_375x160.jpg";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import CancerSrc from "../assets/img/cancer/Cancer_Icon.svg";
import OnlineGP from "../assets/img/cancer/Online GP.png";
import OnlineGPHOL from "../assets/img/cancer/Online GP Hol.png";
import Helpline24 from "../assets/img/cancer/helpline.png";
import Helpline24Hol from "../assets/img/cancer/24-7 helpline Hol.png";
import Phone from "../assets/img/cancer/Phone.png";
import PhoneHol from "../assets/img/cancer/Phone Hol.png";
import { Paths, Urls } from "../constants/UrlConstants";
import { Link } from "react-router-dom";
import {
  getPhoneClaims,
} from "../helpers/ContentStateHelper";

const SkinCancerSupportItemLinks = {
  LinkTo: Paths.Check4CancerSkin,
  LinkText: "Learn more",
  AriaLabel : "Learn more about skin cancer diagnosis service"
};

const BreastCancerSupportItemLinks = {
  LinkTo: Paths.Check4CancerBreast,
  LinkText: "Learn more",
  AriaLabel : "Learn more about breast cancer diagnosis service"
};

const ProstateCancerSupportItemLinks = {
  LinkTo: Paths.Check4CancerProstate,
  LinkText: "Learn more",
  AriaLabel : "Learn more about prostate cancer diagnosis service"
};

const SymptomCancer = {
  Question: "What should I do if I'm concerned about a possible symptom of cancer?",
  Answer: {
    Any: (state) => (
      <React.Fragment>
       <p>
If you're worried about any changes to your breasts or skin or aged 40 and over with confirmation that you've a raised PSA level, you could use these diagnostic services with Check4Cancer without always needing a GP referral first. Call us on
  {" "}
<strong style={{ fontSize: "15px" }}>{getPhoneClaims(state)}</strong> and we'll ask you a few questions to understand what's causing you concern. If it's appropriate and eligible on your plan, we'll offer you an appointment with Check4Cancer, a trusted provider of early cancer detection.
</p>
      </React.Fragment>
    ),
  }
};

const PremiumExcess = {
  Question: "Will using this service impact my No Claims Discount or excess?",
  Answer: {
    Any: (
      <React.Fragment>
        <p>
        If you have an excess or No Claims Discount (NCD), yes. Using the cancer diagnostic pathways with Check4Cancer will impact any excess, NCD or any contribution you usually make towards treatment each year.  You’ll also need to have outpatient diagnostics on your plan to use this service. You can find these details in your 
          {" "}
          <Link style={{ fontSize: "15px" }}
            className={layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            membership documents
          </Link>
          , or in the documents you received when you joined.​
        </p>
      </React.Fragment>
    ),
  }
};

const ServiceAvailable = {
  Question: "Who is this service available to?",
  Answer: {
    Any: (
      <React.Fragment>
        <p>
        The breast, skin and prostate diagnostic pathways are available to all AXA Health members with healthcare benefits for outpatient specialist consultations and diagnostics tests.  If you work for a large business (usually 250 plus employees), check to see if your employer has selected the Check4Cancer service by referring to your 
        {" "}
          <Link style={{ fontSize: "15px" }}
            className={layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            handbook
          </Link>.
        </p>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
        The breast, skin and prostate diagnostic pathways are available to all AXA Health members with healthcare benefits for outpatient specialist consultations and diagnostics tests.  If you work for a large business (usually 250 plus employees), check to see if your employer has selected the Check4Cancer service by referring to your 
        {" "}
          <Link style={{ fontSize: "15px" }}
            className={layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            handbook
          </Link>.
        </p>
      </React.Fragment>
      // <React.Fragment>
      //   <p>
      //     If you're the policyholder, you can view everyone who's covered under
      //     your policy on the Cover details page, under 'Other people on my
      //     policy'.
      //   </p>
      //   <p>
      //     For confidentiality, if you're a family member, you can only view the
      //     policyholder's details.
      //   </p>
      // </React.Fragment>
    )
  }
};

const CancerDiagnosticServices = {
  HeroContent: {
    Heading: "Cancer diagnostic services",
    Header: "Online",
    Check4CancerBannerSrc: Check4CancerBannerSrc,
    Check4CancerBannerSrcMobile: Check4CancerBannerSrcMobile,

    Description: (

      <React.Fragment>
        We know that when you're worried about a potential cancer, speed and reassurance are really important. That's why we're working with Check4Cancer, a provider of early cancer detection.
                <p></p>
                To use this service, check you have the appropriate cover for outpatient specialist consultations and diagnostics tests, you can find this in your
        {" "}
        <Link style={{ fontSize: "18px" }}
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          to={Paths.CoverDocuments}

        >
          membership documents  
        </Link>.{" "}
        <p></p>
        You won’t need a GP referral to access the skin and breast service but will require confirmation of a raised PSA level to access the prostate service.
        <p></p>
        This service is available for members aged <strong style={{ fontSize: "17px" }}>18 and over.</strong>
      </React.Fragment>
    ),
  },
  healthSupportItems: {
    health: [
      {
        IconSrc: CancerSrc,
        Heading: "Skin cancer diagnosis",
        Desc:
          "Have you noticed any changes in your skin? Find out about the skin diagnostic service we offer with Check4Cancer.",
        Links: { Any: [SkinCancerSupportItemLinks] },
      }
      ,
      {
        IconSrc: CancerSrc,
        Heading: "Breast cancer diagnosis",
        Desc:
          
        "Have you noticed any changes in your breasts? Find out about the breast diagnostic service we offer with Check4Cancer.",
        Links:
          { Any: [BreastCancerSupportItemLinks] },
      },
      {
        IconSrc: CancerSrc,
        Heading: "Prostate cancer diagnosis",
        Desc:
          "Aged 40 or over, with raised PSA levels?  Find out about the prostate cancer diagnostic service we offer with Check4Cancer.",
        Links:
          { Any: [ProstateCancerSupportItemLinks] },
      },
    ]
  },

  HeadingLinkTo: Paths.Help,
  HeadingLinkText: "Help",
  HelpSetCancer: {
    helpSet: [
      SymptomCancer,
      PremiumExcess,
      ServiceAvailable
    ],
  },

  Cards: {
    GPAppointment: {
      IconSrc: OnlineGP,
      IconSrcHol: OnlineGPHOL,
      Heading: "GP appointments 24/7",
      Description: "Speak to a doctor when you want to, wherever you are, through your smartphone or laptop using our AXA Doctor at Hand service.",
      LinkText: "FIND OUT MORE",
      LinkTo: Paths.GPAppointments247,
    },

    HealthSupport: {
      IconSrc: Helpline24,
      IconSrcHol: Helpline24Hol,
      Heading: "24/7 health support line",
      Description: "Our nurses and counsellors are here to answer questions 24/7 on a wide range of medical conditions and treatments​.",
      LinkText: "FIND OUT MORE",
      LinkTo: Paths.AskAMedicalExpert,
    },

    CancerSupport: {
      IconSrc: Phone,
      IconSrcHol: PhoneHol,
      Heading: "Cancer support",
      Description: "If you're diagnosed with cancer, you'll be connected to our Cancer Care Team and allocated your own dedicated case manager to support you every step of the way.",
      LinkText: "FIND OUT MORE",
      LinkTo: Urls.CancerSupport,
    }
  }
};
export default CancerDiagnosticServices;
